import React, { Component } from "react";
import { Link } from "react-router-dom";

class Mosaic extends Component {
  render() {
    return null;
  }
}
export default Mosaic;
